/**
 * @generated SignedSource<<b9bef95ea55a25388dcd2acaf3c7b957>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemindersCreateMutationInput = {
  clientMutationId?: string | null;
  memberIds: ReadonlyArray<string>;
  message: string;
  nodeId: string;
};
export type SignersDetailsModal_createReminder_Mutation$variables = {
  input: RemindersCreateMutationInput;
};
export type SignersDetailsModal_createReminder_Mutation$data = {
  readonly createReminder: {
    readonly success: boolean | null;
  } | null;
};
export type SignersDetailsModal_createReminder_Mutation = {
  response: SignersDetailsModal_createReminder_Mutation$data;
  variables: SignersDetailsModal_createReminder_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemindersCreateMutationPayload",
    "kind": "LinkedField",
    "name": "createReminder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignersDetailsModal_createReminder_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignersDetailsModal_createReminder_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aaed8b8a73426fdcfc1ed5f8218d0f54",
    "id": null,
    "metadata": {},
    "name": "SignersDetailsModal_createReminder_Mutation",
    "operationKind": "mutation",
    "text": "mutation SignersDetailsModal_createReminder_Mutation(\n  $input: RemindersCreateMutationInput!\n) {\n  createReminder(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "0729b4ef7f85355eb8954ae1f9b982e8";

export default node;
